<div class="barcode">
    <div class="barcode__holder">
        <img directive-image-preload (click)="handleCodeClick($event)" [url]="(image$ | async)?.data" alt="Card Number"
            class="barcode__img" *ngIf="(image$ | async)?.hasSucceeded === true && (image$ | async)?.data !== null"
            (onLoaded)="handleOnCodeLoaded($event)">
        <shared-loader-for-placeholder class="barcode__loader"
            *ngIf="(image$ | async)?.isDownloading === false && imgLoaded === false">
        </shared-loader-for-placeholder>
    </div>

    <div class="barcode__card-no" *ngIf="showCardNumber && (cardNo$ | async)">
        Card number {{(cardNo$ | async)}}
    </div>
</div>